(function () {
  'use strict';

  // Do not run while editing the Shopify theme
  if (window.Shopify && Shopify.designMode) {
    return;
  }

  /*
   * Elements where customers should still be able to
   * select, copy and paste normally.
   */
  function isEditableElement(element) {
    if (!element || !element.closest) {
      return false;
    }

    return !!element.closest(
      'input, textarea, select, button, [contenteditable="true"], [contenteditable=""]'
    );
  }

  /*
   * Prevent right-click/context menu.
   */
  document.addEventListener('contextmenu', function (event) {
    if (!isEditableElement(event.target)) {
      event.preventDefault();
    }
  });

  /*
   * Prevent text selection.
   *
   * Form fields and editable elements remain usable.
   */
  document.addEventListener('selectstart', function (event) {
    if (!isEditableElement(event.target)) {
      event.preventDefault();
    }
  });

  /*
   * Prevent dragging images.
   */
  document.addEventListener('dragstart', function (event) {
    if (
      event.target &&
      event.target.tagName &&
      event.target.tagName.toLowerCase() === 'img'
    ) {
      event.preventDefault();
    }
  });

  /*
   * Prevent copying website content.
   *
   * Form fields remain unaffected.
   */
  document.addEventListener('copy', function (event) {
    if (!isEditableElement(event.target)) {
      event.preventDefault();
    }
  });

  /*
   * Prevent cutting website content.
   */
  document.addEventListener('cut', function (event) {
    if (!isEditableElement(event.target)) {
      event.preventDefault();
    }
  });

  /*
   * Block common shortcuts used for copying,
   * viewing source and opening developer tools.
   */
  document.addEventListener('keydown', function (event) {
    if (isEditableElement(event.target)) {
      return;
    }

    const key = event.key.toLowerCase();
    const modifier = event.ctrlKey || event.metaKey;

    // Ctrl/Cmd + C
    if (modifier && key === 'c') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + X
    if (modifier && key === 'x') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + A
    if (modifier && key === 'a') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + U - View Source
    if (modifier && key === 'u') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + S - Save page
    if (modifier && key === 's') {
      event.preventDefault();
      return;
    }

    // F12 - Developer Tools
    if (event.key === 'F12') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + Shift + I - Developer Tools
    if (modifier && event.shiftKey && key === 'i') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + Shift + J - Developer Console
    if (modifier && event.shiftKey && key === 'j') {
      event.preventDefault();
      return;
    }

    // Ctrl/Cmd + Shift + C - Inspect Element
    if (modifier && event.shiftKey && key === 'c') {
      event.preventDefault();
      return;
    }
  });
})();